import { react2angular } from 'react2angular';
import TeamChatLink from './TeamChatLink';

angular
  .module('bb.util')
  .component(
    'teamChatLink',
    react2angular(TeamChatLink, ['openContactDrawer', 'teamId', 'teamName']),
  );
